import * as React from "react"
import { useEffect, useRef, useState } from "react"
import ReactPlayer from "react-player/lazy/"
import Section from "../../../../core/layout/main/section/Section"
import Card from "../../blocks/card/Card"
import * as classNames from "./VideoPageCardSection.module.scss"
import Button from "../../blocks/button/Button"
import Image from "../../blocks/image/Image"

const VideoPageCardSection = ({
  media,
  mediaLink,
  typeMedia,
  linkedPage,
  cardTitle,
  cardText,
  cardButtonText,
  isCardAlignLeft,
  alternativeText,
  videoPreview,
  mime,
  formats,
  linkedArticle,
  title,
  description,
}) => {
  const [playing, setPlaying] = useState(false)
  const [isMounted, setIsMounted] = useState(false)
  const [hideIcon, setHideIcon] = useState(false)
  const [playerReady, setPlayerReady] = useState(false)
  const videoRef = useRef(null)

  useEffect(() => {
    setIsMounted(true)
  }, [isMounted])

  const handleDecoratifMouseEvents = () => {
    if (!playerReady) {
      return
    }
    const video = videoRef.current.getInternalPlayer()
    video.addEventListener("mouseover", function (e) {
      video.play()
    })

    video.addEventListener("mouseout", function (e) {
      video.pause()
    })
  }

  const handleInformativeClickEvents = () => {
    setPlaying(!playing)
  }

  const handleFocuseMediaClickEvents = () => {
    if (videoRef.current) {
      const player = videoRef.current.getInternalPlayer()
      if (player) {
        player.paused ? player.play() : player.pause()
      }
    }
  }

  return (
    <Section
      className={`video pbl-6 mt-6 ${classNames.videoCarte}`}
      container="large"
    >
      <div className="loadin">
        <h2 className={classNames.title}>{title}</h2>
        <p className={classNames.desc}>{description}</p>
        <div
          className={`${
            isCardAlignLeft ? "justify-content-end" : "justify-content-start"
          } ${classNames.videoWrapper} ${"media"}`}
        >
          {typeMedia === "Ambiance" && media && isMounted && (
            <ReactPlayer
              ref={videoRef}
              controls={typeMedia === "Focus"}
              muted
              loop
              height="none"
              width="none"
              playing={playing}
              url={media}
              light={
                videoPreview ? (
                  <Image
                  dataSizesPreset={'hero'}
                  formats={videoPreview?.attributes.formats}
                  imgHeight="auto"
                  imgWidth="100%"
                  imgSrc={videoPreview?.attributes.url}
                  />
                ) : (
                  false
                )
              }
              onClick={handleFocuseMediaClickEvents}
              onMouseOver={() => {
                setPlaying(true)
              }}
              onMouseOut={() => {
                setPlaying(false)
              }}
            ></ReactPlayer>
          )}
          {typeMedia === "Focus" && media && (
            <div class="w-100">
              <div
                className={`${
                  isCardAlignLeft
                    ? "justify-content-end"
                    : "justify-content-start"
                } ${classNames.videoWrapper}`}
                onClick={handleFocuseMediaClickEvents}
              >
                {isMounted && (
                  <div className="w-100">
                  <ReactPlayer
                    style={{ width: "100%", }}
                    ref={videoRef}
                    controls={typeMedia === "Focus"}
                    loop
                    playing={videoPreview ? true : playing}
                    height="none"
                    width="none"
                    onClick={handleFocuseMediaClickEvents}
                    onPause={() => setPlaying(false)}
                    onPlay={() => setPlaying(true)}
                    onEnded={() => setPlaying(false)}
                    url={media}
                    playsinline
                    light={
                      videoPreview ? (
                        <Image
                          dataSizesPreset={'hero'}
                          formats={videoPreview?.attributes.formats}
                          imgHeight="auto"
                          imgWidth="100%"
                          imgSrc={videoPreview?.attributes.url}
                        />
                      ) : (
                        false
                      )
                    }
                  ></ReactPlayer>
                  </div>
                )}
              </div>
              {videoRef.current &&
                <Image
                  className={classNames.logoPlay}
                  style={playing ? { opacity: "0" } : {}}
                  imgAlt="bouton play"
                  imgSrc="https://spaces-01.fra1.digitaloceanspaces.com//paritel-www/upload/aab694448f0271481d77680de5555ae0.png"
                  onClick={handleFocuseMediaClickEvents}
                />
              }
            </div>
          )}

          {typeMedia === "Focus" && mediaLink && (
            <div class="w-100">
              <div
                className={`${
                  isCardAlignLeft
                    ? "justify-content-end"
                    : "justify-content-start"
                } ${classNames.videoWrapper}`}
              >
                {isMounted && (
                  <div className="w-100">
                  <ReactPlayer
                    style={{ width: "100%", height: "400px" }}
                    height="none"
                    width="none"
                    playing={videoPreview ? true : playing}
                    loop
                    controls={typeMedia === "Focus"}
                    url={mediaLink}
                    config={{
                      youtube: {
                        playerVars: {
                          modestbranding: 1,
                          showinfo: 0,
                        },
                      },
                    }}
                    light={
                      videoPreview ? (
                        <Image
                          dataSizesPreset={'hero'}
                          formats={videoPreview?.attributes.formats}
                          imgHeight="auto"
                          imgWidth="100%"
                          imgSrc={videoPreview?.attributes.url}
                        />
                      ) : (
                        false
                      )
                    }
                    onClick={
                      typeMedia === "Focus"
                        ? handleInformativeClickEvents
                        : null
                    }
                    onPause={() => setPlaying(false)}
                    onPlay={() => setPlaying(true)}
                    onEnded={() => setPlaying(false)}
                    onStart={() => setHideIcon(true)}
                  />
                  </div>
                )}
              </div>
              {typeMedia === "Focus" && hideIcon && (
                <Image
                  className={classNames.logoPlay}
                  style={playing ? { opacity: "0" } : {}}
                  imgAlt="bouton play"
                  imgSrc="https://spaces-01.fra1.digitaloceanspaces.com//paritel-www/upload/aab694448f0271481d77680de5555ae0.png"
                  onClick={
                    media
                      ? handleFocuseMediaClickEvents
                      : handleInformativeClickEvents
                  }
                />
              )}
            </div>
          )}

          {typeMedia === "Ambiance" && mediaLink && (
            <div class="w-100"
              onMouseOver={() => {
                setPlaying(true)
              }}
              onFocus={() => {
                setPlaying(true)
              }}
              onMouseOut={() => {
                setPlaying(false)
              }}
              onBlur={() => {
                setPlaying(false)
              }}
            >
              {isMounted && (
                <div className="w-100">
                <ReactPlayer
                  ref={videoRef}
                  url={mediaLink}
                  height="none"
                  width="none"
                  muted
                  controls={false}
                  playing={playing}
                  onReady={() => setPlayerReady(true)}
                  onClick={
                    typeMedia === "Focus" ? handleInformativeClickEvents : null
                  }
                  onMouseOver={
                    typeMedia === "Ambiance" ? handleDecoratifMouseEvents : null
                  }
                  onMouseOut={
                    typeMedia === "Ambiance" ? handleDecoratifMouseEvents : null
                  }
                  config={{
                    youtube: {
                      playerVars: {
                        controls: 0,
                        modestbranding: 1,
                      },
                    },
                  }}
                  light={
                    videoPreview ? (
                      <Image
                        dataSizesPreset={'hero'}
                        formats={videoPreview?.attributes.formats}
                        imgHeight="auto"
                        imgWidth="100%"
                        imgSrc={videoPreview?.attributes.url}
                      />
                    ) : (
                      false
                    )
                  }
                />
                </div>
              )}
            </div>
          )}
          {mime && mime.startsWith("image/") && (
            <div style={{ maxWidth: "100%", height: "auto" }}>
              <Image
                style={{ maxWidth: "100%", height: "auto" }}
                imgSrc={media}
                imgAlt={alternativeText}
                dataSizesPreset={'hero'}
                formats={formats}
              />
            </div>
          )}
          <Card
            type={isCardAlignLeft ? "left" : "right"}
            className="pin-6 pbl-6"
          >
            <h2 className="secondary-text-color">{cardTitle}</h2>
            <p className="mt-3">{cardText}</p>
            <Button
              aspect="classique"
              color="primary"
              to={linkedPage ? linkedPage : "/articles/" + linkedArticle}
              className="mt-3"
            >
              {cardButtonText}
            </Button>
          </Card>
        </div>
      </div>
    </Section>
  )
}

export const name = "VideoPageCardSection"

export const init = (componentData, pageContext) => {
  return (
    <VideoPageCardSection
      key={componentData.id}
      title={componentData.label}
      description={componentData.description}
      typeMedia={componentData.typeMediaPage || componentData.typeMediaArticle}
      mediaLink={componentData.linkMedia}
      media={componentData.media?.data?.attributes.url}
      alternativeText={componentData.media?.data?.attributes.alternativeText}
      mime={componentData.media?.data?.attributes.mime}
      formats={componentData.media?.data?.attributes.formats}
      linkedPage={componentData.page?.data?.attributes.route}
      linkedArticle={componentData.article?.data?.attributes.slug}
      titlePage={componentData.page?.data?.attributes.title}
      descriptionPage={componentData.page?.data?.attributes.description}
      cardTitle={componentData.cardTitle}
      cardText={componentData.cardText}
      cardButtonText={componentData.cardButtonText}
      isCardAlignLeft={componentData.isCardAlignLeft}
      videoPreview={componentData.videoPreview?.data}
    />
  )
}

export default VideoPageCardSection
